// API client tipado pra `/api/crm/pipeline` (Story 11.12 — dashboard de pipeline).
// Padrão: wrapper sobre `apiClient` (axios) + Zod parse na resposta (Tier 2).
//
// Fonte de tipos: schemas Zod do `@control-center/shared` (back+front).
// Envelope do backend: { data: { period, summary, funnel, conversion_by_origin, proposals_expiring } }.

import {
  pipelineSummaryResponseSchema,
  type PipelinePeriod,
  type PipelineSummaryData,
} from '@control-center/shared';

import { apiClient } from './api-client';

export interface PipelineSummaryParams {
  period: PipelinePeriod;
  /** Filtra todos os widgets por responsável (omit = todos). */
  responsibleUserId?: string;
}

/** GET /api/crm/pipeline/summary — dados consolidados do dashboard de pipeline. */
export async function fetchPipelineSummary(
  params: PipelineSummaryParams,
  signal?: AbortSignal,
): Promise<PipelineSummaryData> {
  const query: Record<string, string> = { period: params.period };
  if (params.responsibleUserId) query.responsibleUserId = params.responsibleUserId;
  const { data } = await apiClient.get('/api/crm/pipeline/summary', { params: query, signal });
  return pipelineSummaryResponseSchema.parse(data).data;
}
